<template>
    <div id="codeLoadEditRulePanel" class="form-wrapper-codeload">
        <PanelDropdown v-model="folderMap" :label="$t('folderMap')" :options="folderOptions" placeholder="None"
            :tooltip="$t('tooltips.shared.folderMap')" style="padding-left: 1rem; padding-right: 1rem;" />
        <FolderFileName v-model="localForm.fileName" :max-length="260" :titleLabel="$t('folderFileName')" :placeholder="$t('enterfolderFileName')" :tooltip="$t('tooltips.shared.folderFileName')" style="padding-left: 1rem; padding-right: 1rem;" @validation="onValidation" />
        <FeatureToggle class="feature-toggle-div" v-model="tabControl" type="codeLoad" label="" :form="localForm"
            :tooltip="$t('tooltips.codeLoad')"></FeatureToggle>
        <ExpertNotes v-model="localForm.expertNotes" :max-length="1000" :label="$t('expertNotes')" style="padding-left: 1rem; padding-right: 1rem;" />
    </div>
</template>

<script setup>
import { defineProps, ref, watch, defineEmits, computed } from 'vue'
import FeatureToggle from './components/featureToggle.vue'
import PanelInput from './components/panelInput.vue'
import PanelDropdown from './components/panelDropdown.vue'
import ExpertNotes from './components/expertNotes.vue';
import { useStore } from "@/store";
import FolderFileName from './components/folderFileName.vue';
const store = useStore();
const props = defineProps({
    form: {
        type: Object,
        required: true,
    },
    formType: {
        type: String,
        default: 'codeLoad'
    }
})
const emit = defineEmits(['update:form', 'validation'])
const folderOptions = computed(() => {
    const original = store.state.general.folderMaps || [];
    return [{ label: "None", value: null }, { label: "Any", value: -1 }, ...original];
});

const localForm = computed({
    get() {
        return props.form;
    },
    set(newVal) {
        emit('update:form', newVal);
    }
});
const tabControl = ref(true)

function onValidation(valid) {
    emit('validation', valid)
}

const folderMap = computed({
    get() {
        return localForm.value.isFolderMapIdAny ? -1 : localForm.value.folderMapId;
    },
    set(val) {
        if (val === -1) {
            localForm.value.isFolderMapIdAny = true;
            localForm.value.folderMapId = -1;
        } else if (val === null) {
            localForm.value.isFolderMapIdAny = false;
            localForm.value.folderMapId = null;
        } else {
            localForm.value.isFolderMapIdAny = false;
            localForm.value.folderMapId = val;
        }
    },
});

</script>
<style>
.form-wrapper-codeload {
    font-size: 0.8rem !important;
}

.custom-input {
    width: inherit;
}

.label-check {
    margin-left: 5px;
    margin-bottom: 0px !important;
}

.form-label {
    color: #164B6C;
    font-weight: bold;
    margin-left: 8px;
}

.info-icon {
    margin-left: 3px;
}
</style>
